
  
// Script Généré le : 10/01/2026 10:38:10 via ModelGenerator.nt
//  ExtUser.ts
// Chemin de sortie : ..\..\..\front-shared\paf-shared\projects\ngx-paf-common\src\lib\Models\ExtUser.ts

import {ExtUserStatut } from "./ExtUserStatut";
import {Contact } from "./Contact";
export class ExtUser {

  // int Id
  public Id: number=0;

  // string Email
  public Email?: string=null;

  // int ContactId
  public ContactId: number=0;

  // int StatusId
  public StatusId: number=0;

  // DateTime CreationDate
  public CreationDate: Date= new Date();

  // string IntUserIdCreate
  public IntUserIdCreate?: string=null;

  // DateTime? UpdateDate
  public UpdateDate?: Date=null;

  // string IntUserIdUpdate
  public IntUserIdUpdate?: string=null;

  // DateTime? LastPwdDate
  public LastPwdDate?: Date=null;

  // int? PwdDuration
  public PwdDuration?: number=null;

  // string Password
  public Password?: string=null;

  // DateTime? StatusDate
  public StatusDate?: Date=null;

  // bool? TopRFE
  public TopRFE?: boolean=null;

  // DateTime? TopRFEDate
  public TopRFEDate?: Date=null;

  // ExtUserStatut ExtUserStatut
  public ExtUserStatut: ExtUserStatut=null;

  // Contact Contact
  public Contact: Contact=null;
}